import Class from './c-widget';
import './c-widget@.vue';

export default Class;